import React from 'react';
import Button from '@material-ui/core/Button';

import './PrimaryButton.scss';

const PrimaryButton = React.forwardRef(({
    text,
    icon,
    className,
    component,
    type,
    handleClick,
    disabled,
    buttonStyle,
    ...props
}, ref) => {
    const getClassName = () => {
        const classNames = ['primary-button'];

        if (className) {
            classNames.push(className);
        }

        if (buttonStyle) {
            classNames.push(buttonStyle);
        }

        return classNames.join(' ');
    };

    return (
        <Button
            variant='contained'
            className={getClassName()}
            type={type}
            onClick={handleClick}
            component={component ? component : 'button'}
            disabled={disabled}
            disableElevation={true}
            ref={ref}
            {...props}
        >
            {icon && icon}
            {text}
        </Button>
    );
});

export default PrimaryButton;
